export default prod => {
  const isntZero = element => element.availability > 0;

  const isZero = element => element.availability === 0;

  return prod
    .filter(isntZero)
    .concat(prod.filter(isZero))
}